import React from "react"
import PropTypes from 'prop-types';
import { graphql } from "gatsby"
import Layout from '../components/layout';
import Box from 'components/box';
import Title from 'components/title';
import PostPage from 'components/postpage';
import Footer from 'components/footer';
import Aside from 'components/aside';
import { PostContainer } from 'components/postitems/postitems-wrapper.css';
import { ContentContainer } from 'components/postitems/postitems-wrapper.css';

export default function BlogPost({ data }) {
  const post = data.markdownRemark
  return (
    <Layout>
      <ContentContainer className="container">
          <h2 className="post-title">
            {post.frontmatter.title}
          </h2>
          <PostPage post={post} />
          <Aside />
      </ContentContainer>
      <div style={{ height: '50vh' }} />
      <Footer />
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        author
        date
        intro_paragraph
        categories
        image {
          childImageSharp {
            fluid(maxWidth: 400, maxHeight: 250) {
              src
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`